// extracted by mini-css-extract-plugin
export var container = "_5o-0";
export var error = "_5o-9";
export var label = "_5o-5";
export var light = "_5o-6";
export var md = "_5o-3";
export var sm = "_5o-2";
export var thin = "_5o-8";
export var thinBold = "_5o-7";
export var vertical = "_5o-4";
export var xs = "_5o-1";